import {createContext} from 'react';
import {IFormGroup} from '../types';

const FormContext = createContext<{ formGroup: IFormGroup, formRef: HTMLFormElement }>({formGroup: null, formRef: null});
FormContext.displayName = 'FormContext';
export default FormContext;
